import { roleActionSelectors } from "../Selectors/index";

const initValue = {
  loading: false,
  rows: [],
};

export const roleReducer = (state = initValue, { type, payload }) => {
  switch (type) {
    case roleActionSelectors.GET_USER:
      return {
        ...state,
        loading: true,
      };
    case roleActionSelectors.GET_USER_SUCCESS:
      return {
        loading: false,
        rows: payload,
      };

    default:
      return state;
  }
};